import { LoyaltyMember } from '~Hooks';
import { i18nProps } from '~Translations';

/** What the rest of the POS calls this member. */
export const displayName = (member: LoyaltyMember, i18n: i18nProps): string =>
  member.name || member.email || i18n('Loyalty.UnnamedMember');

/** "Aug 2024" - the resolution the panel needs, without a date library. */
export const memberSince = (registeredAt: string): string =>
  new Date(registeredAt).toLocaleDateString(undefined, {
    month: 'short',
    year: 'numeric',
  });
